"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerReactSelect = void 0;
Object.defineProperty(exports, "components", {
  enumerable: true,
  get: function get() {
    return _reactSelect.components;
  }
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSelect = _interopRequireWildcard(require("react-select"));
var _reduxForm = require("redux-form");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./APReactSelect.css");
var _excluded = ["input", "label", "meta", "info", "options", "customClass", "onSelect", "classModifiers", "components"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var customStyles = {
  menu: function menu(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      background: "rgb(var(--pc__background-secondary))"
    });
  },
  menuPortal: function menuPortal(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      zIndex: 9999
    });
  },
  control: function control(base, state) {
    return _objectSpread(_objectSpread({}, base), {}, {
      fontSize: 'var(--input__font-size)',
      minHeight: 'auto',
      height: 'var(--input__height)',
      padding: '0 2.5rem 0 1rem',
      borderRadius: '2px',
      flexShrink: 0,
      color: 'var(--input__color)',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: state.isFocused ? 'var(--input__border-color--hover)' : 'var(--input__border-color)',
      background: state.isFocused ? 'var(--input__bg-color--focus);' : 'var(--input__bg-color)',
      boxShadow: 'none',
      '&:hover': {
        borderColor: 'var(--input__border-color--hover)'
      }
    });
  },
  container: function container(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      padding: 0
    });
  },
  option: function option(base, _ref) {
    var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused;
    return _objectSpread(_objectSpread({}, base), {}, {
      paddingLeft: '1.2rem',
      borderBottom: '1px solid #1F232E',
      backgroundColor: isDisabled ? "transparent" : isFocused ? 'rgb(var(--pc__background-tertiary))' : "rgb(var(--pc__background-secondary))",
      color: isDisabled ? '#888' : 'inherit',
      // Faint text for disabled options
      opacity: isDisabled ? 0.5 : 1,
      // Fade disabled options
      pointerEvents: isDisabled ? 'none' : 'auto' // Prevent selection
    });
  },
  input: function input(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      color: 'white'
    });
  },
  placeholder: function placeholder(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      color: 'white'
    });
  },
  noOptionsMessage: function noOptionsMessage(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      color: 'white'
    });
  },
  singleValue: function singleValue(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      color: 'var(--input__color)',
      padding: '0.4rem 0px'
    });
  },
  valueContainer: function valueContainer(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      padding: 0
    });
  },
  indicatorsContainer: function indicatorsContainer(base) {
    return _objectSpread({}, base);
  },
  menuList: function menuList(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      paddingTop: 0,
      paddingBottom: 0
    });
  }
};
var InnerReactSelect = exports.InnerReactSelect = function InnerReactSelect(props) {
  var input = props.input,
    label = props.label,
    meta = props.meta,
    info = props.info,
    options = props.options,
    customClass = props.customClass,
    onSelect = props.onSelect,
    classModifiers = props.classModifiers,
    providedComponents = props.components,
    passedProps = _objectWithoutProperties(props, _excluded);
  var baseClasses = (0, _cssClassesHelper.getBEMClasses)(['react-select', customClass]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group ".concat(baseClasses('select-wrapper', classModifiers))
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "ap--label ".concat(baseClasses('select-label'))
  }, label), /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], _extends({}, input, passedProps, {
    className: "form-control ".concat(baseClasses('select')),
    options: options,
    isOptionDisabled: passedProps.isOptionDisabled,
    onChange: function onChange(e) {
      if (onSelect) onSelect(e);
      input && input.onChange(e);
    },
    onBlur: function onBlur() {
      input && input.onBlur(input.value);
    },
    menuPortalTarget: document.body,
    styles: customStyles,
    components: _objectSpread({
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      IndicatorsContainer: function IndicatorsContainer() {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: baseClasses('triangles-container')
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "arrow-left arrow"
        }), /*#__PURE__*/_react["default"].createElement("span", {
          className: "arrow-right arrow"
        }));
      }
    }, providedComponents)
  })), /*#__PURE__*/_react["default"].createElement("small", {
    className: "form-text-muted ".concat(baseClasses('select-info'))
  }, info), meta && meta.dirty && meta.error && /*#__PURE__*/_react["default"].createElement("span", {
    className: baseClasses('select-error')
  }, meta.error));
};
var APSelect = function APSelect(props) {
  return /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, _extends({
    name: props.name,
    component: InnerReactSelect
  }, props));
};
APSelect.defaultProps = {
  name: '',
  label: '',
  classes: 'input',
  customClass: 'custom-react-select',
  classModifiers: '',
  info: '',
  disabled: false,
  multiple: false,
  required: false,
  options: []
};
APSelect.propTypes = {
  name: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string,
  classes: _propTypes["default"].string,
  customClass: _propTypes["default"].string,
  classModifiers: _propTypes["default"].string,
  info: _propTypes["default"].oneOf(_propTypes["default"].string, _propTypes["default"].node),
  onSelect: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  multiple: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  options: _propTypes["default"].array.isRequired,
  components: _propTypes["default"].shape({})
};
var _default = exports["default"] = APSelect;